const AUTH_SERVER_MESSAGE_KEY_MAP = {
    'Please provide all details!': 'auth.serverMessages.provideAllDetails',
    'Invalid Email!': 'auth.serverMessages.invalidEmail',
    'Invalid Password!': 'auth.serverMessages.invalidPassword',
    'Please verify your email before login.': 'auth.serverMessages.verifyEmailBeforeLogin',
    'Trouble in login! Please contact support Team.': 'auth.serverMessages.loginTrouble',
    'Account already exist! Please try login.': 'auth.serverMessages.accountAlreadyExists',
    'Failed to save OTP session. Please try again.': 'auth.serverMessages.otpSessionSaveFailed',
    'OTP sent successfully to your email.': 'auth.serverMessages.otpSentToEmail',
    'Unable to send OTP right now. Please try again later.': 'auth.serverMessages.otpSendUnavailable',
    'OTP session expired. Please register again.': 'auth.serverMessages.registrationOtpSessionExpired',
    'Please provide email and OTP.': 'auth.serverMessages.provideEmailAndOtp',
    'Email does not match the OTP request.': 'auth.serverMessages.otpEmailMismatch',
    'OTP expired. Please request a new OTP.': 'auth.serverMessages.otpExpired',
    'Invalid OTP.': 'auth.serverMessages.invalidOtp',
    'Failed to create User!': 'auth.serverMessages.userCreateFailed',
    'Failed to create session!': 'auth.serverMessages.sessionCreateFailed',
    'User Registration successfully!': 'auth.serverMessages.registrationSuccess',
    'Trouble in Registration! Please contact admin.': 'auth.serverMessages.registrationTrouble',
    'Direct registration is disabled. Please request OTP and verify email to register.': 'auth.serverMessages.directRegistrationDisabled',
    'Please provide email.': 'auth.serverMessages.provideEmail',
    'No account found with this email.': 'auth.serverMessages.noAccountFound',
    'Password reset OTP sent successfully.': 'auth.serverMessages.passwordResetOtpSent',
    'No valid OTP request found.': 'auth.serverMessages.noValidOtpRequest',
    'OTP verified successfully.': 'auth.serverMessages.otpVerified',
    'Unable to verify OTP right now.': 'auth.serverMessages.otpVerifyUnavailable',
    'Please provide token and new password.': 'auth.serverMessages.provideTokenAndPassword',
    'Invalid or expired reset token.': 'auth.serverMessages.invalidOrExpiredResetToken',
    'Reset token expired. Please try again.': 'auth.serverMessages.resetTokenExpired',
    'Password reset successfully.': 'auth.serverMessages.passwordResetSuccess',
    'Unable to reset password right now.': 'auth.serverMessages.passwordResetUnavailable'
}

export const translateAuthServerMessage = (message, t, fallbackKey = 'auth.messages.serverError') => {
    const normalizedMessage = String(message || '').trim()
    if (!normalizedMessage) {
        return t(fallbackKey)
    }

    const mappedKey = AUTH_SERVER_MESSAGE_KEY_MAP[normalizedMessage]
    if (mappedKey) {
        return t(mappedKey)
    }

    return normalizedMessage
}
